/** @internal */
export async function delay(intervalMillis: number): Promise<void> {
    return new Promise((res) => setTimeout(res, intervalMillis))
}
